import React, { Fragment, useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { resetPassword, checkLinkExpiry } from "../../actions/auth";
import { SITE_URL } from "../../actions/types";
import { Link } from "react-router-dom";

// import '../../AdminStyle';
import "../../css/sb-admin-2.min.css";
import swal from "sweetalert";

const ForgotPassword = ({
  resetPassword,
  checkLinkExpiry,
  auth: { isAuthenticated },
  alert,
  match,
}) => {
  const [formData, setFormData] = useState({
    confirm_password: "",
    password: "",
  });
  const [passwordValidationError, setPasswordValidationError] = useState("");
  const [confirmPasswordValidationError, setConfirmPasswordValidationError] =
    useState("");
  const { confirm_password, password } = formData;
  const [successMessage, setSuccessMessage] = useState("");
  const [notice, setNotice] = useState("");

  const [hide, sethide] = useState("password");
  const [eye_toggle, seteyetoggle] = useState(
    <i className="fas fa-eye-slash align-middle"></i>
  );

  const [hide2, sethide2] = useState("password");
  const [eye_toggle2, seteyetoggle2] = useState(
    <i className="fas fa-eye-slash align-middle"></i>
  );
  const validatePassword = (password) => {
    if (!password || !password.trimStart())
      return "Please enter a new password.";
    if (password.length < 8)
      return "The new password must be at least 8 characters long.";
    if (password.length > 16) return "Password cannot exceed 16 characters";
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;
    return passwordRegex.test(password)
      ? ""
      : "The new password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.";
  };
  const validatePassword2 = (password) => {
    if (!password || !password.trimStart())
      return "Please enter a confirm password.";
    if (password.length < 8)
      return "The new password must be at least 8 characters long.";
    if (password.length > 16) return "Password cannot exceed 16 characters";
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;
    return passwordRegex.test(password)
      ? ""
      : "The new password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.";
  };
  const onChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = e.target.value.trimStart();
    setFormData({ ...formData, [e.target.name]: trimmedValue });
    if (name === "password") {
      setPasswordValidationError(validatePassword(value));
    }
    if (name === "confirm_password") {
      setConfirmPasswordValidationError(validatePassword2(value));
    }
  };

  const onSubmit = async (e) => {
    setPasswordValidationError("");
    setConfirmPasswordValidationError("");
    setSuccessMessage("");
    e.preventDefault();
    var formData = {};
    formData.password = password;
    formData.confirm_password = confirm_password;

    if (!password) {
      setPasswordValidationError("Please enter a new password.");
    }
    if (!confirm_password) {
      setConfirmPasswordValidationError("Please enter a confirm password.");
    }
    resetPassword(match.params.id, formData)
      .then((promiseValue) => {
        if (promiseValue.status == 1) {
          swal("", "Password updated successfully", "success").then(() => {
            window.location.href = "/admin-login";
          });
        }
        promiseValue.forEach((element) => {
          if (element.param == "password") {
            setPasswordValidationError(element.msg);
          }
          if (element.param == "confirm_password") {
            setConfirmPasswordValidationError(element.msg);
          }
        });
      })
      .catch((error) => console.log(error));
  };
  useEffect(() => {
    checkLinkExpiry(match.params.id).then((res) => {
      if (res.status == 2) {
        setNotice("No records found!");
      } else if (res.status == 0) {
        setNotice(
          "Link is expired. Please verify your email again to get verfication link."
        );
      }
      //setApiHit(true);
    });
  }, []);

  const toggle_password = () => {
    if (hide == "password") {
      seteyetoggle(<i className="fas fa-eye align-middle"></i>);
      sethide("text");
    } else {
      seteyetoggle(<i className="fas fa-eye-slash align-middle"></i>);
      sethide("password");
    }
  };

  const toggle_password2 = () => {
    if (hide2 == "password") {
      seteyetoggle2(<i className="fas fa-eye align-middle"></i>);
      sethide2("text");
    } else {
      seteyetoggle2(<i className="fas fa-eye-slash align-middle"></i>);
      sethide2("password");
    }
  };

  const alertLength = alert.length;
  if (isAuthenticated) {
    return <Redirect to="/admin-dashboard" />;
  }
  return (
    <Fragment>
      <div className="container">
        {/* Outer Row */}
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-12 col-md-9 pt-5">
            <div className="card o-hidden border-0 shadow-lg my-3">
              <div className="card-body p-0">
                {/* Nested Row within Card Body */}
                <div className="row">
                  {/* <div className="col-lg-6 d-none d-lg-block bg-login-image" /> */}
                  <div className="col-lg-12">
                    <div className="p-5">
                      {notice != "" ? (
                        <div className="alert alert-danger">
                          {notice}
                          <hr />
                          <div className="row">
                            <div
                              className="col login-link"
                              style={{ fontWeight: "600", textAlign: "center" }}
                            >
                              <Link to="/admin-login">
                                Go Back to Login Page
                              </Link>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="text-center">
                            {/* <h1 className="h4 text-gray-900 mb-2">Welcome Back!</h1> */}
                            <img
                              src={`/img/group-6.svg`}
                              onError={(e) => {
                                e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                                e.target.src = "img/noImage.png"; // Fallback image if loading fails
                              }}
                              className="mb-4 w35"
                            />
                          </div>
                          {successMessage != "" && (
                            <div className="alert alert-success">
                              Password changed successfully.{" "}
                              <Link to="/admin-login">Click here </Link> to
                              Login
                            </div>
                          )}

                          <form className="user" onSubmit={(e) => onSubmit(e)}>
                            <div>
                              <label>
                                Password <span className="text-danger">*</span>
                              </label>
                            </div>
                            <div className="form-group password-input-new">
                              <input
                                type={hide}
                                name="password"
                                className="form-control form-control-user"
                                id="exampleInputEmail"
                                aria-describedby="passwordHelp"
                                onChange={(e) => onChange(e)}
                                value={formData.password || ""}
                                maxLength={20}
                                placeholder="Enter Password"
                              />

                              <button
                                type="button"
                                id="button-addon2"
                                className="eye-icon-btn"
                                onClick={toggle_password}
                              >
                                {eye_toggle}
                              </button>
                              {passwordValidationError != "" ? (
                                <div className="help-block font-small-3">
                                  <p className="text-danger">
                                    {passwordValidationError}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                            <div>
                              <label>
                                Confirm Password{" "}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                            <div className="form-group password-input-new">
                              <input
                                type={hide2}
                                name="confirm_password"
                                className="form-control form-control-user"
                                aria-describedby="passwordHelp"
                                maxLength={20}
                                onChange={(e) => onChange(e)}
                                value={formData.confirm_password || ""}
                                placeholder="Confirm Password"
                              />

                              <button
                                type="button"
                                id="button-addon2"
                                className="eye-icon-btn"
                                onClick={toggle_password2}
                              >
                                {eye_toggle2}
                              </button>
                              {confirmPasswordValidationError != "" ? (
                                <div className="help-block font-small-3">
                                  <p className="text-danger">
                                    {confirmPasswordValidationError}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>

                            <input
                              type="submit"
                              className="btn btn-primary btn-user btn-block"
                              value="Update Password"
                            />
                          </form>
                          <hr />
                          <div className="row">
                            <div
                              className="col login-link"
                              style={{ fontWeight: "600", textAlign: "center" }}
                            >
                              <Link to="/admin-login">
                                Go Back to Login Page
                              </Link>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  alert: state.alert,
});

export default connect(mapStateToProps, { resetPassword, checkLinkExpiry })(
  ForgotPassword
);
